<template lang="pug">
.vprStartworkInstructionComponent
  .navbar
    a.back( @click="onBackClick" )
      ui-svg-icon.backIcon(
        name="arrow-back"
        :size="16"
      )
      span Назад

  .contentWrapper
    .title Инструкция для стартовой диагностики
    .text( v-html="instructionHtml" )
    ui-button.submit( @click="$emit('do-vpr')" ) Перейти к выполнению
</template>

<script>
import { inject } from 'vue'
import { useRouter } from 'vue-router'

export default {
  emits: ['do-vpr'],
  setup () {
    const controller = inject('controller')
    const router = useRouter()

    return {
      instructionHtml: controller.childVpr.value.userItem.vpr.startwork.instructionHtml,
      onBackClick: () => router.push({ name: 'VprContents', params: { id: controller.childVpr.value.userItem.id } })
    }
  }
}
</script>

<style lang="sass" scoped>
.vprStartworkInstructionComponent
  > .navbar
    margin-bottom: 7.5*$u
    > a
      width: fit-content
      display: flex
      align-items: center
      color: $cBlue
      cursor: pointer

      > span
        @include font('t16-medium')
        margin-left: 2.5*$u

      &:hover
        color: $cLightBlue
      &:active
        color: $cDarkBlue

    @media (max-width: $padWidth)
      display: none

  > .contentWrapper
    border-radius: $brL
    background-color: $cWhite
    padding: 12.5*$u
    @media (max-width: 948px)
      padding: 5*$u

    > .title
      margin-bottom: 7.5*$u
      @include font('h2')
      @media (max-width: 948px)
        @include font('m-h2')

    > .text
      margin-bottom: 7.5*$u
      @include font('t18-regular')
      @media (max-width: 948px)
        @include font('m-t18-regular')

</style>
